import React, { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import api from "@/lib/api";
import { PacketView } from "@/components/packet/PacketView";
import { saveBlob } from "@/components/packet/RecitalPacketTab";

export function FamilyPacket({ pid }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    if (pid) { api.get(`/packets/family/${pid}`).then((r) => setData(r.data)).catch(() => setData(false)); }
  }, [pid]);
  if (!data) return null;
  const name = (data.content.title || "recital-packet").replace(/[^\w -]/g, "").trim().replace(/\s+/g, "-");
  const downloads = [
    ...(data.dancers.length ? [{ label: "Download my family's packet", testid: "family-packet-download-personal", onClick: () => saveBlob(`/packets/family/${pid}/pdf?personal=true`, `${name}-family.pdf`) }] : []),
    { label: data.dancers.length ? "General packet" : "Download Recital Packet", testid: "family-packet-download-general", onClick: () => saveBlob(`/packets/family/${pid}/pdf?personal=false`, `${name}.pdf`) },
  ];
  return (
    <section className="mb-8" data-testid="family-packet">
      <h2 className="font-head text-xl mb-3 flex items-center gap-2"><BookOpen className="w-5 h-5 text-teal" />Recital Packet</h2>
      <PacketView pid={pid} content={data.content} auto={data.auto} dancers={data.dancers} downloads={downloads}
        onOpenFile={(f) => saveBlob(`/files/${f.file_id}`, f.name || "file")} />
      <p className="text-xs text-muted-foreground mt-2">Updated {new Date(data.published_at).toLocaleDateString()} · version {data.version}</p>
    </section>
  );
}
